import { render } from "./AlterarSenhaForm.vue?vue&type=template&id=02ec7af2&scoped=true"
import script from "./AlterarSenhaForm.vue?vue&type=script&lang=js"
export * from "./AlterarSenhaForm.vue?vue&type=script&lang=js"

import "./AlterarSenhaForm.vue?vue&type=style&index=0&id=02ec7af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02ec7af2"]])

export default __exports__